<template>
  <div>
    <div class="reportTable">
      <div class="df">
        <div class="adjust-height">
          <button
            :disabled="loading"
            class="btn button btn-outline-dark"
            @click="handlePaymentsForSubscriptions()"
            style="height: 42px"
          >
            Pobierz płatności
          </button>
        </div>

        <div class="adjust-height">
          <p>Subskrypcja</p>
          <select @change="handleSubParamChange($event)">
            <option value="">Wszystkie</option>
            <option
              v-for="param in filteringParams"
              :key="param.id"
              :value="param"
            >
              {{ param }}
            </option>
          </select>
        </div>

        <div class="adjust-height">
          <p>Status</p>
          <select @change="handleStatusParamChange($event)">
            <option value="">Wszystkie</option>
            <option v-for="status in statuses" :key="status" :value="status">
              {{ status }}
            </option>
          </select>
        </div>

        <div class="adjust-height">
          <p class="mb-0 ml-2">Data zamówienia</p>
          <div class="datepickers">
            <datepicker
              :monday-first="true"
              :language="pl"
              v-model="selectedDateFrom"
              name="dateFrom"
              :placeholder="'Od'"
              style="padding: 0"
            ></datepicker>
            <datepicker
              :language="pl"
              v-model="selectedDateTo"
              name="dateTo"
              :placeholder="'Do'"
              style="padding: 0"
            ></datepicker>
          </div>
        </div>
        <!-- <button
        class="btn btn-sm btn-styles adjust-height mr-4"
        @click="clearDates()"
      >
        Wyczyść daty
      </button> -->

        <div class="adjust-height">
          <p>Rodzaj raportu</p>
          <select @change="handleReportTypeForDownload($event)">
            <option value="">Wszystkie</option>
            <option v-for="type in filteringParams" :key="type" :value="type">
              {{ type }}
            </option>
          </select>
          <img
            class="ml-4"
            @click="downloadSubscriptionsReport()"
            style="cursor: pointer"
            src="@/icons/download.svg"
            alt=""
          />
        </div>
      </div>

      <div>
        <div v-if="!loading">
          <table
            class="table borderless"
            v-if="subscriptionReport && subscriptionReport.length > 0"
          >
            <thead>
              <tr class="tr-table">
                <th>ID</th>
                <th></th>
                <th>Imię i nazwisko</th>
                <th>Kategoria</th>
                <th>Podkategoria, Opcja</th>
                <th>Data zamówienia</th>
                <th>Data rozpoczęcia</th>
                <th>Data zakończenia</th>
                <th>Data ostatniej płatności</th>
                <th>Rodzaj subskrypcji</th>
                <th>Czy opłacone na kolejny miesiąc?</th>
                <th>Metoda płatności</th>
                <th>Numer telefonu</th>
                <th>Data modyfikacji</th>
                <th>Cena</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(sub, index) in subscriptionReport.filter(
                  (s) =>
                    s.isMainRow ||
                    showedMoreSubscriptionOrders.includes(`${s.orderId}`)
                )"
                :key="`${sub.phone}_${index}`"
                :class="
                  !sub.isMainRow ||
                  showedMoreSubscriptionOrders.includes(`${sub.orderId}`)
                    ? `nested-subscription ${
                        !sub.isPaidForNextMonth && sub.orderState === 'ACCEPTED'
                          ? 'not-renewed'
                          : ''
                      } ${sub.isFirstOrderRow ? 'first-order-row' : ''} ${
                        sub.isLastOrderRow ? 'last-order-row' : ''
                      }`
                    : !sub.isPaidForNextMonth && sub.orderState === 'ACCEPTED'
                    ? 'not-renewed'
                    : ''
                "
              >
                <!-- :style="
                  !sub.isMainRow ||
                  showedMoreSubscriptionOrders.includes(`${sub.orderId}`)
                    ? `background: rgba(238, 125, 72, ${
                        nestedSubscriptionOpacities[sub.orderId]
                      })`
                    : ''
                " -->
                <td>
                  <img
                    @click="copyText(sub.orderId)"
                    style="cursor: pointer"
                    src="@/icons/copy-icons.svg"
                    alt=""
                  />
                </td>
                <td>
                  <div
                    :style="
                      addedMainRow[`${sub.orderId}`] > 1 && sub.isMainRow
                        ? 'display: flex; gap: 1rem'
                        : 'visibility: hidden'
                    "
                  >
                    <i
                      v-if="
                        !showedMoreSubscriptionOrders.includes(`${sub.orderId}`)
                      "
                      class="fa fa-arrow-circle-down arrow-icon"
                      aria-hidden="true"
                      @click="showMoreSubscriptionsOrders(`${sub.orderId}`)"
                    ></i>
                    <i
                      v-else
                      class="fa fa-arrow-circle-up arrow-icon"
                      aria-hidden="true"
                      @click="hideMoreSubscriptionsOrders(`${sub.orderId}`)"
                    ></i>
                    <span>
                      {{
                        subscriptionReport.filter(
                          (s) => `${s.orderId}` === `${sub.orderId}`
                        ).length
                      }}
                    </span>
                  </div>
                </td>

                <td>{{ sub.firstName }} {{ sub.lastName }}</td>
                <td>{{ sub.serviceCategory }}</td>
                <td>{{ sub.serviceSubcategory }}, {{ sub.service }}</td>
                <td>{{ formattedDateWithoutTime(sub.orderDate) }}</td>
                <td>{{ formattedDateWithoutTime(sub.subscriptionStart) }}</td>
                <td>
                  {{
                    checkSubscriptionEnd(sub)
                      ? ""
                      : formattedDateWithoutTime(
                          sub.isMainRow
                            ? sub.subscriptionFullEnd
                            : sub.subscriptionEnd
                        )
                  }}
                </td>
                <td>{{ formattedDateWithTime(sub.lastPaymentDate) }}</td>
                <td>{{ sub.subscriptionType }}</td>
                <td>
                  {{
                    sub.isMainRow && sub.orderState === "ACCEPTED"
                      ? sub.isPaidForNextMonth
                        ? "Tak"
                        : "Nie"
                      : "-"
                  }}
                </td>
                <td>{{ sub.paymentMethod }}</td>
                <!-- <td>{{ sub.pesel }}</td> -->
                <!-- <td>{{ sub.birthdate }}</td> -->
                <td>{{ sub.phone }}</td>

                <!-- <td>{{ sub.gender }}</td>
          <td>{{ sub.email }}</td>
          <td>{{ sub.city }}</td> -->
                <td>
                  {{
                    sub.lastManuallyModificationDate
                      ? formattedDateWithoutTime(
                          sub.lastManuallyModificationDate
                        )
                      : "-"
                  }}
                </td>
                <td>
                  {{ sub.price }}
                </td>
                <td>
                  <div class="inline-buttons">
                    <img
                      :id="`showTooltipButton_${sub.id}`"
                      @mouseover="showSubTooltip(sub)"
                      v-if="sub.isMainRow && sub.plannedAutoChange"
                      style="cursor: pointer"
                      src="@/icons/more-info.svg"
                      alt=""
                      width="40px"
                    />
                    <button
                      :disabled="loading"
                      @click="handlePaymentsForSubscriptions(sub.userId)"
                      v-show="
                        sub.orderState === 'ACCEPTED' && !sub.isPaidForNextMonth
                      "
                      class="button btn btn-outline-dark"
                    >
                      POBIERZ PŁAT.
                    </button>

                    <button
                      v-if="sub.orderState === 'ACCEPTED' && sub.isMainRow"
                      class="button btn btn-outline-dark"
                      @click="selectSub(sub)"
                      data-toggle="modal"
                      data-target="#sub-edit"
                    >
                      {{ sub.orderState }}
                    </button>
                    <button
                      v-else-if="
                        sub.orderState === 'UNREALIZED' && sub.isMainRow
                      "
                      class="button btn btn-outline-danger"
                      @click="selectSub(sub)"
                      data-toggle="modal"
                      data-target="#sub-edit"
                    >
                      {{ sub.orderState }}
                    </button>
                    <button
                      v-else-if="sub.orderState === 'FINISHED' && sub.isMainRow"
                      class="button btn btn-outline-yellow"
                      @click="selectSub(sub)"
                      data-toggle="modal"
                      data-target="#sub-edit"
                    >
                      {{ sub.orderState }}
                    </button>

                    <button
                      class="button btn btn-outline-gradient"
                      @click="selectSub(sub)"
                      data-toggle="modal"
                      data-target="#sub-details"
                    >
                      Więcej
                    </button>

                    <img
                      class="profile-icon"
                      @click="moveToProfile(sub.userId)"
                      src="../../icons/user.svg"
                    />
                  </div>
                </td>

                <custom-modal
                  :title="`Szczegóły zamówienia '${selectedSub.firstName} ${selectedSub.lastName}' ID: ${selectedSub.orderId}`"
                  id="sub-details"
                >
                  <template #content>
                    <table class="table borderless" v-if="selectedSub">
                      <thead>
                        <tr class="tr-table">
                          <th>Imię i nazwisko</th>
                          <th>Zamawiający</th>
                          <th>Telefon zamawiającego</th>
                          <th>Płeć</th>
                          <th>PESEL</th>
                          <th>Data urodzenia</th>
                          <th>Email</th>
                          <th>Miasto</th>
                          <th>Faktura</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{ selectedSub.firstName }}
                            {{ selectedSub.lastName }}
                          </td>
                          <td>
                            {{ selectedSub.userFirstName }}
                            {{ selectedSub.userLastName }}
                          </td>
                          <td>{{ selectedSub.userPhone }}</td>
                          <td>{{ selectedSub.gender }}</td>
                          <td>{{ selectedSub.pesel }}</td>
                          <td>{{ selectedSub.birthdate }}</td>
                          <td>{{ selectedSub.email }}</td>
                          <td>{{ selectedSub.city }}</td>
                          <td>
                            <div class="invoiceButtons">
                              <div class="flex">
                                <img
                                  @click="fetchInvoiceLink(selectedSub.id)"
                                  style="cursor: pointer"
                                  src="@/icons/download.svg"
                                  alt=""
                                />
                                <img
                                  @click="
                                    copyInvoiceLinkToClipboard(selectedSub.id)
                                  "
                                  style="cursor: pointer; margin-left: 5px"
                                  src="@/icons/copy-icons.svg"
                                  alt=""
                                />
                              </div>

                              <a
                                :href="invoiceLink"
                                :id="`downloadLink${selectedSub.id}`"
                                style="visibility: hidden"
                                target="_blank"
                              ></a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </custom-modal>

                <custom-modal
                  :title="`Edycja zamówienia '${selectedSub.firstName} ${selectedSub.lastName}' ID: ${selectedSub.orderId}`"
                  id="sub-edit"
                >
                  <template #content>
                    <div class="edit-container">
                      <div class="edit-row">
                        <div class="edit-container-label">Wybierz status</div>
                        <div>
                          <select v-model="editSubStatus">
                            <option
                              v-for="status in statuses"
                              :key="status"
                              :value="status"
                            >
                              {{ status }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div
                        class="edit-row"
                        v-if="decisionOptions && decisionOptions.length > 0"
                      >
                        <div class="edit-container-label">Decyzja</div>
                        <div>
                          <select v-model="editSubDecision">
                            <option
                              v-for="decision in decisionOptions"
                              :key="decision"
                              :value="decision.value"
                            >
                              {{ decision.label }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="edit-row">
                        <div class="edit-container-label">
                          Data zmiany statusu
                        </div>

                        <datepicker
                          :monday-first="true"
                          :language="pl"
                          v-model="editSubDate"
                          name="editSubDate"
                          :placeholder="'Data zmiany'"
                          style="padding: 0"
                        ></datepicker>
                      </div>

                      <div class="edit-row">
                        <div class="edit-container-label">Podaj powód</div>
                      </div>
                      <div
                        class="edit-row"
                        style="
                          position: relative;
                          width: fit-content;
                          margin-bottom: 2rem;
                        "
                      >
                        <textarea
                          v-model="editSubReason"
                          id="editSubReason"
                          type="text"
                          required
                          minlength="1"
                          maxlength="1000"
                          placeholder="Powód"
                          rows="5"
                          cols="80"
                          style="padding: 5px"
                        />
                        <p
                          style="position: absolute; right: 5px; bottom: -25px"
                        >
                          {{ editSubReason.length }}/1000
                        </p>
                      </div>

                      <div class="edit-row">
                        <button
                          class="btn button btn-outline-dark"
                          @click="handleEditSub"
                        >
                          Zapisz
                        </button>
                      </div>
                    </div>
                  </template>
                </custom-modal>
              </tr>
            </tbody>
          </table>
          <h3 v-else class="ml-3"><b>Brak subskrypcji</b></h3>
        </div>
        <div
          class="spinner-border text-secondary loader"
          role="status"
          v-if="loading"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../axios";
import shared from "../../shared";
import { pl } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import CustomModal from "../CustomModal.vue";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light-border.css";
import moment from "moment";
export default {
  props: ["userId"],
  components: { Datepicker, CustomModal },
  name: "SubscriptionsReportsView",
  data() {
    return {
      pl: pl,
      filterType: "",
      selectedDateFrom: null,
      selectedDateTo: null,
      addedMainRow: {},
      showedMoreSubscriptionOrders: [],
      invoiceLink: "",
      selectedOrderStatus: "",
      selectedReportTypeForDownload: "",
      selectedSub: {},
      editSubStatus: "ACCEPTED",
      editSubDecision: false,
      editSubReason: "",
      editSubDate: null,
      loading: false,
      nestedSubscriptionOpacities: {},
      nestedSubscriptionOpacity: 0.2,
    };
  },

  created() {
    this.formattedDateWithTime = shared.formattedDateAsNumbers;
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
  },
  async mounted() {
    try {
      this.loading = true;
      await this.$store.dispatch("fetchSubsFilteringParams");
    } catch (error) {
      console.log(error);
    }
    // fetchUserSubscriptions owns the report loader, so a filter change during this load keeps it on.
    await this.fetchUserSubscriptions();
  },

  methods: {
    checkSubscriptionEnd(subscription) {
      const subscriptionStartPlus12Months = moment(
        subscription.subscriptionStart
      )
        .add(12, "months")
        .endOf("month");

      return (
        !subscription.subscriptionType.includes("roczna") &&
        subscription.orderState === "ACCEPTED" &&
        moment().isAfter(
          moment(subscriptionStartPlus12Months.toDate()).set("date", 1)
        ) &&
        subscriptionStartPlus12Months.isAfter(
          moment(subscription.subscriptionFullEnd).set("date", 1)
        ) &&
        subscription.isMainRow
      );
    },
    async handlePaymentsForSubscriptions(userId) {
      this.loading = true;
      try {
        let body = { usersIds: [] };
        if (userId) {
          body.usersIds.push(userId);
        }
        if (this.userId && !body.usersIds.includes(this.userId)) {
          body.usersIds.push(this.userId);
        }
        const response = await this.$store.dispatch(
          "handlePaymentsForSubscriptions",
          body
        );

        if (response && response.message == "OK") {
          this.$notify({
            group: "success",
            text: "Funkcja do pobrania płatności za subskrypcje została wykonana",
          });
          await this.fetchUserSubscriptions();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    showSubTooltip(sub) {
      const plannedAutoChange = sub.plannedAutoChange;
      tippy(`#showTooltipButton_${sub.id}`, {
        allowHTML: true,
        content: `
        <p>Nowy status: ${plannedAutoChange.orderStateToSet}</p>
        <p>Decyzja: ${plannedAutoChange.orderStateToSetInfo}</p>
        <p>Data zmiany statusu: ${this.formattedDateWithoutTime(
          plannedAutoChange.plannedChangeDate
        )}</p>
        <p>${plannedAutoChange.reason}</p>
        `,
      });
    },
    async handleEditSub() {
      const body = {
        orderId: this.selectedSub.orderId,
        type: "CHANGE_ORDER_STATE",
        plannedChangeDate: this.editSubDate,
        orderStateToSet: this.editSubStatus,
        orderStateToSetInfo:
          this.editSubStatus === "UNREALIZED" ? this.editSubDecision : "",
        reason: this.editSubReason,
        withMoneyReturn: this.editSubDecision,
      };

      await this.$store.dispatch("createAutoPlannedChangeForOrder", body);
      document.getElementById("sub-edit-close").click();

      this.fetchUserSubscriptions();
    },
    selectSub(sub) {
      this.selectedSub = sub;
    },
    moveToProfile(userId) {
      const routeData = this.$router.resolve(`/users/id/${userId}`);
      window.open(routeData.href, "_blank");
    },

    async copyText(text) {
      const selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
      this.$notify({
        group: "success",
        text: "ID zamówienia zostało skopiowane",
      });
    },

    async fetchUserSubscriptions() {
      let isLatest = true;
      try {
        this.loading = true;
        this.addedMainRow = {};
        this.showedMoreSubscriptionOrders = [];
        const body = {
          date_from: this.selectedDateFrom
            ? this.selectedDateFrom.toISOString().split("T")[0]
            : "2021-01-01",
          date_to: this.selectedDateTo
            ? this.selectedDateTo.toISOString().split("T")[0]
            : "2999-01-01",
          type: this.filterType ? this.filterType : "",
          orderState: this.selectedOrderStatus,
          userId: this.userId,
        };
        isLatest = await this.$store.dispatch("fetchSubscriptionsReport", body);
      } catch (error) {
        console.log(error);
      } finally {
        // A cancelled older call must not switch off the loader of the newer one.
        if (isLatest) this.loading = false;
      }
    },

    handleReportTypeForDownload(e) {
      this.selectedReportTypeForDownload = e.target.value;
    },
    handleStatusParamChange(e) {
      this.selectedOrderStatus = e.target.value;
      this.fetchUserSubscriptions();
    },

    handleSubParamChange(e) {
      this.filterType = e.target.value;
      this.fetchUserSubscriptions();
    },
    async clearDates() {
      this.selectedDateFrom = null;
      this.selectedDateTo = null;
      this.fetchUserSubscriptions();
    },

    async downloadSubscriptionsReport() {
      if (!this.loading) {
        try {
          const url = `/api/admin/userSubscriptions/file`;
          const params = {
            date_from: this.selectedDateFrom
              ? this.selectedDateFrom.toISOString().split("T")[0]
              : "2021-01-01",
            date_to: this.selectedDateTo
              ? this.selectedDateTo.toISOString().split("T")[0]
              : "2030-01-01",
            type: this.filterType ? this.filterType : null,
            reportType: this.selectedReportTypeForDownload,
            orderState: this.selectedOrderStatus,
            userId: this.userId,
          };

          axios(url, {
            params,
            method: "GET",
            headers: {
              "Content-Disposition":
                "attachment; filename=subscriptions_report.xls",
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "blob",
          })
            .then((response) => {
              const fileURL = window.URL.createObjectURL(
                new Blob([response.data])
              );
              const fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute("download", "subscriptions_report.xls");
              document.body.appendChild(fileLink);
              fileLink.click();
            })
            .catch((err) => console.log(err));
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },

    showMoreSubscriptionsOrders(orderId) {
      if (!this.showedMoreSubscriptionOrders.includes(orderId)) {
        this.showedMoreSubscriptionOrders.push(orderId);
        // this.nestedSubscriptionOpacities[orderId] =
        //   this.nestedSubscriptionOpacity;
        // this.nestedSubscriptionOpacity += 0.15;
        // if (this.nestedSubscriptionOpacity > 1) {
        //   this.nestedSubscriptionOpacity = 0.3;
        // }
      }
    },

    hideMoreSubscriptionsOrders(orderId) {
      this.showedMoreSubscriptionOrders =
        this.showedMoreSubscriptionOrders.filter((o) => o !== orderId);
    },

    async fetchInvoiceLink(id) {
      this.invoiceLink = null;
      await axios
        .get(`/api/payment/invoice/subscription/${id}`)
        .then((response) => {
          this.invoiceLink = response.data;
        });

      document.getElementById(`downloadLink${id}`).click();
    },

    async copyInvoiceLinkToClipboard(id) {
      let link = "";
      await axios
        .get(`/api/payment/invoice/subscription/${id}`)
        .then((response) => {
          link = response.data;
        });
      navigator.clipboard.writeText(link);
      this.$notify({
        group: "success",
        text: "Link do faktury został skopiowany",
      });
    },
    resetMainRows() {
      this.addedMainRow = {};
    },
  },

  computed: {
    decisionOptions() {
      if (this.editSubStatus === "UNREALIZED") {
        return [
          { value: false, label: "Anuluj bez zwrotu pieniędzy" },
          { value: true, label: "Anuluj ze zwrotem pieniędzy" },
        ];
      } else {
        return [];
      }
    },
    statuses() {
      return ["ACCEPTED", "FINISHED", "UNREALIZED"];
    },
    subscriptionReport() {
      this.resetMainRows();
      let reports = this.$store.getters.getSubscriptionReport;

      if (reports && reports.length > 0) {
        reports.forEach((r, index) => {
          if (!this.addedMainRow[`${r.orderId}`]) {
            this.addedMainRow[`${r.orderId}`] = 1;
            r.isMainRow = true;
            if (
              reports[index - 1] &&
              reports[index - 1].orderId !== r.orderId
            ) {
              r.isFirstOrderRow = true;
            }
            if (
              reports[index + 1] &&
              reports[index + 1].orderId !== r.orderId
            ) {
              r.isLastOrderRow = true;
            }
          } else {
            r.isMainRow = false;
            this.addedMainRow[`${r.orderId}`] =
              this.addedMainRow[`${r.orderId}`] + 1;
            if (
              reports[index + 1] &&
              reports[index + 1].orderId !== r.orderId
            ) {
              r.isLastOrderRow = true;
            }
          }
        });
      }

      return reports;
    },
    filteringParams() {
      return this.$store.getters.getFilteringParams;
    },
  },

  watch: {
    selectedDateFrom() {
      if (this.selectedDateFrom) {
        this.fetchUserSubscriptions();
      }
    },
    selectedDateTo() {
      if (this.selectedDateTo) {
        this.fetchUserSubscriptions();
      }
    },
  },
};
</script>

<style scoped>
.first-order-row {
  border-top: 2px solid black;
}
.last-order-row {
  border-bottom: 2px solid black;
}
.nested-subscription {
  border-right: 2px solid black;
  border-left: 2px solid black;
}
.toggle {
  margin-right: 10px;
  align-items: center;
  display: flex;
}
.toggle i {
  font-size: 18px;
  cursor: pointer;
  margin: 0;
  margin-right: 1rem;
}
.df {
  display: flex;
  margin-bottom: 3rem;
}
.arrow-icon {
  cursor: pointer;
  font-size: 20px;
}
.adjust-height {
  height: 30px;
  margin-top: 15px;
}
.not-renewed {
  background: rgba(226, 3, 126, 0.07);
  /* background: rgba(232, 16, 135, 0.5); */
}
.inline-buttons {
  display: flex;
  gap: 1rem;
}
button {
  border-radius: 0;
  width: 100px;
}
.profile-icon {
  cursor: pointer;
}
.edit-container {
  text-align: left;
}
.edit-row {
  display: flex;
  align-items: center;
  gap: 2rem;
}
.edit-container-label {
  width: 90px;
}
.edit-row select {
  width: 180px;
}
</style>
